/**
 * Matches P.O. Box addresses written any common way, with or without periods, spaces, or dashes:
 * PO Box, P.O. Box, P O Box, POBox, PO BX, POB, PO Drawer, PO 123, P.O. 123, PO #12, P.O. No. 5,
 * Post Office Box, Postal Box, Post Office 12, Box 44. A zero typed for the "O" counts too.
 */
const PO_BOX_PATTERN =
  /\b(?:p[\s.-]*[o0][\s.-]*(?:box|bx|drawer|b\b|(?:#|no\.?|num(?:ber)?\.?)?\s*#?\s*\d)|post(?:al)?[\s.-]*(?:office[\s.-]*)?(?:box|bx)|post[\s.-]*office\b|pob\b|(?:box|bx)\s*#?\s*\d)/i;

export const PO_BOX_MESSAGE = "We can't ship to P.O. Boxes. Please enter a street address.";

export function isPOBox(...lines: (string | null | undefined)[]): boolean {
  return lines.some((line) => !!line && PO_BOX_PATTERN.test(line));
}
